import { APICore } from './apiCore';

const api = new APICore();

interface ContactPayload {
    name: string;
    mobile_no: string;
    profile: File;
    group_name: string;
}


export function CreateContacts(data: ContactPayload): Promise<any> {
    const baseUrl = '/contacts';
    const formData = new FormData();
    formData.append('contact_name', data.name);
    formData.append('mobile_no', data.mobile_no);
    formData.append('profile', data.profile);
    formData.append('group_name', data.group_name);

    return api.create(baseUrl, formData);
}
function showContacts() {
    const baseUrl = '/contacts/list';
    return api.show(`${baseUrl}`);
}
function showContactsDetails(contactId: any) {
    const baseUrl = `/contacts/${contactId}`;
    return api.show(baseUrl);
}
export function ImportContact(data: FormData): Promise<any> {
    const baseUrl = '/contacts/import';
    return api.create(baseUrl, data);
}
export function updateContact(contactId: string, ContactData: any) {
    const baseUrl = `/contacts/${contactId}`;
    return api.update(baseUrl, ContactData);
}
export function delete_contact(id: string) {
    return api.get(`/contacts/delete/${id}`);
}
export { showContacts, showContactsDetails };



